<template>
  <div class="relative slinky-menu transition-all duration-300 ease-in-out overflow-hidden" :style="{ height: height }">
    <slinky-list
      :nodes="nodes"
      :style="{ transform: `translateX(${left}%)`, height: 'auto' }"
      :active="true"
      @next="next"
      @back="back"
      @close="close"
    ></slinky-list>
  </div>
</template>
<script>
import SlinkyList from './SlinkyList'
export default {
  name: 'Slinky',
  components: {
    SlinkyList
  },
  props: {
    nodes: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      item: 0,
      step: 100,
      left: 0,
      height: 'auto'
    }
  },
  mounted () {
    this.calculateHeight()
  },
  methods: {
    next(data) {
      this.left = this.left - this.step
      this.$nextTick(() => {
        this.calculateHeight()
      })
    },
    back(data) {
      this.left = this.left + this.step
      this.$nextTick(() => {
        this.calculateHeight()
      })
    },
    close() {
      this.$emit('close')
    },
    calculateHeight() {
      const active = this.$el.querySelectorAll('.slinky-menu ul.active')
      this.height = active[active.length - 1].clientHeight + 'px'
    }
  }
}
</script>
<style>
.slinky-menu li ul {
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transform: translateX(100%);
}
.slinky-menu  ul.active {
  pointer-events: auto;
  opacity: 1;
  visibility: visible;
}
</style>
